<ng-container *ngIf="review">
  <h5 *ngIf="review.attributes.star_rating >=3" class="ds-heading--s mb-3">{{review.attributes.title}}</h5>
  <div
    *ngFor="let answer of reviewAnswers"
    class="mt-4"
  >
    <h6 class="ds-heading--xs">{{answer.text}}</h6>
    <p>{{answer.value}}</p>
  </div>
  <a
    (click)="reviewModalService.openReadReviewDialog(review.attributes.url)"
    class="my-3 underline--hover--black ds-color--black ds-cursor--pointer focusable focusable__element offset-none"
    href="javascript:void(0)"
  >
    {{'productReview.readThisReviewOnG2' | cxTranslate}}
  </a>
</ng-container>
